import { Controller } from "stimulus";

export default class StatsComponentController extends Controller {
    static targets = ["link"]

    linkTargetConnected(el) {
        const frameId = el.dataset.turboFrame;
        if (!frameId) return;

        const frame = document.getElementById(frameId);
        // The selected border lives on the tab's wrapper (see LinkStatComponent#container_classes), not the link.
        const tab = el.parentElement;
        frame.addEventListener("turbo:before-frame-render", () => {
            const selected = frame.src.startsWith(el.href);
            tab.classList.toggle("border-b-4", selected);
            tab.classList.toggle("border-b-purple-500", selected);
        });
    }
}

